import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestRestoreReseller } from "./restoreReseller.request";

const useRestoreReseller = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchResellersAndCounters = useRefetchQuery(["reseller"]);

  return useMutation({
    mutationFn: requestRestoreReseller,
    ...options,
    onSuccess: (...args) => {
      refetchResellersAndCounters();
      options?.onSuccess?.(...args);
    }
  });
};

export default useRestoreReseller;
